<template>
  <div class="content">
    <h1 class="title is-3">Allgemeine Geschäftsbedingungen</h1>
    <h2 class="title is-5" id="1">1. Allgemeines – Geltungsbereich</h2>
    <p>
      1.1 Die folgenden Allgemeinen Geschäftsbedingungen gelten für alle
      Geschäftsbeziehungen zwischen dem Kunden und Florian Freund
      Webentwicklung, nachfolgend als "uns" bezeichnet. Maßgeblich ist jeweils
      die zum Zeitpunkt des Vertragsschlusses gültige Fassung.
    </p>
    <p>
      1.2 Abweichende, entgegenstehende oder ergänzende Allgemeine
      Geschäftsbedingungen des Kunden werden, selbst bei Kenntnis, nicht
      Vertragsbestandteil, es sei denn, ihrer Geltung wird ausdrücklich
      zugestimmt.
    </p>

    <h2 class="title is-5" id="2">2. Vertragsschluss</h2>
    <p>
      2.1 Unsere Angebote sind freibleibend und unverbindlich. Technische sowie
      sonstige Änderungen bleiben im Rahmen des Zumutbaren vorbehalten.
    </p>
    <p>
      2.2 Mit der Bestellung erklärt der Kunde verbindlich sein Vertragsangebot.
      Wir werden den Zugang der Bestellung des Kunden unverzüglich bestätigen.
      Die Zugangsbestätigung stellt noch keine verbindliche Annahme der
      Bestellung dar. Die Zugangsbestätigung kann mit der Annahmeerklärung
      verbunden werden.
    </p>
    <p>
      2.3 Wir sind berechtigt, das in der Bestellung liegende Vertragsangebot
      innerhalb einer Frist von 5 Werktagen nach Eingang bei uns anzunehmen. Wir
      sind aber auch berechtigt, die Annahme der Bestellung, etwa nach Prüfung
      der Bonität des Kunden, abzulehnen.
    </p>

    <h2 class="title is-5" id="3">3. Leistungsumfang</h2>
    <p>
      3.1 Wir gewährleisten für die Infrastruktur unserer Rechenzentren eine
      Netzwerkverfügbarkeit von 96,9 % im Jahresmittel. Ist die Sicherheit des
      Netzbetriebes oder die Aufrechterhaltung der Netzintegrität gefährdet,
      können wir den Zugang zu den Leistungen je nach Erfordernis vorübergehend
      beschränken.
    </p>
    <p>
      3.2 Im Übrigen ergibt sich der Leistungsumfang aus der im Zeitpunkt der
      Bestellung geltenden Angebotsinformation, dem Bestellformular sowie den
      jeweils geltenden monatlichen Sonderangeboten.
    </p>
    <p>
      3.3 Technische Limitationen sind in den System Policies geregelt, die
      unter
      <a href="https://confcloud.de/rechtliches/system-policies" target="_blank"
        >https://confcloud.de/rechtliches/system-policies</a
      >
      eingesehen oder angefordert werden können.
    </p>
    <p>
      3.4 Technische Supportleistungen sind nicht in den Angeboten enthalten.
      Sofern diese gewünscht und in Anspruch genommen werden, werden sie
      gesondert berechnet. Die jeweils gültigen Preise sind einsehbar unter
      <a href="https://confcloud.de/preise" target="_blank"
        >https://confcloud.de.</a
      >
    </p>

    <h2 class="title is-5" id="4">4. Datensicherheit</h2>
    <p>
      4.1 Soweit Daten an uns übermittelt werden, stellt der Kunde
      Sicherheitskopien her. Soweit dies im jeweiligen Angebot enthalten ist,
      werden die Server regelmäßig gesichert. Für den Fall eines dennoch
      auftretenden Datenverlustes ist der Kunde verpflichtet, die betreffenden
      Datenbestände nochmals unentgeltlich an uns zu übermitteln.
    </p>
    <p>
      4.2 Der Kunde ist verpflichtet, vor jeder eigenen oder in Auftrag
      gegebenen Änderung eine vollständige Datensicherung durchzuführen.
    </p>
    <p>
      4.3 Der Kunde erhält zur Pflege seines Angebotes eine Nutzerkennung und
      ein Passwort. Er ist verpflichtet, dies vertraulich zu behandeln und
      haftet für jeden Missbrauch, der aus einer unberechtigten Verwendung des
      Passwortes resultiert. Erlangt der Kunde davon Kenntnis, dass unbefugten
      Dritten das Passwort bekannt ist, hat er uns hiervon unverzüglich zu
      informieren. Sollten infolge Verschuldens des Kunden Dritte durch
      Missbrauch der Passwörter Leistungen von uns nutzen, haftet der Kunde uns
      gegenüber auf Nutzungsentgelt und Schadensersatz. Im Verdachtsfall hat der
      Kunde deshalb die Möglichkeit, ein neues Kennwort anzufordern, das wir dem
      Kunden dann zusenden.
    </p>

    <h2 class="title is-5" id="5">5. Datenschutz</h2>
    <p>
      5.1 Unsere Datenschutzpraxis steht im Einklang mit der
      Datenschutz-Grundverordnung (DSGVO) und mit dem Bundesdatenschutzgesetz
      (BDSG) sowie dem Telemediengesetz (TMG).
    </p>
    <p>
      5.2 Personenbezogene Daten des Kunden werden nur erhoben und verwendet,
      soweit sie für die Begründung, inhaltliche Ausgestaltung oder Änderung des
      Vertragsverhältnisses erforderlich sind. Der Kunde verpflichtet sich,
      diese Daten in seinem Online-Administrationsbereich stets auf dem
      aktuellen Stand zu halten.
    </p>
    <p>
      5.3 Die E-Mail-Adresse des Kunden nutzen wir nur für
      Informations-Schreiben zu den Aufträgen, für Rechnungen und sofern der
      Kunde nicht widerspricht, zur Kundenpflege sowie, falls vom Kunden
      gewünscht, für eigene Newsletter.
    </p>
    <p>
      5.4 Wir geben keine personenbezogenen Kundendaten an Dritte weiter.
      Ausgenommen hiervon sind Dienstleistungspartner, soweit dies zur
      Ermittlung des Entgelts und zur Abrechnung mit dem Kunden erforderlich
      ist.
    </p>
    <p>
      5.5 Der Kunde hat ein Recht auf Auskunft sowie ein Recht auf Berichtigung,
      Sperrung und Löschung seiner gespeicherten Daten. Sofern einer Löschung
      gesetzliche oder vertragliche Aufbewahrungspflichten oder sonstige
      gesetzliche Gründe entgegenstehen, werden die Daten gesperrt.
    </p>

    <h2 class="title is-5" id="6">6. Veröffentlichte Inhalte</h2>
    <p>
      6.1 Der Kunde ist verpflichtet, die von ihm ins Internet eingestellten
      Inhalte als eigene oder fremde Inhalte zu kennzeichnen und seinen
      vollständigen Namen und seine Anschrift darzustellen.
    </p>
    <p>
      Darüber hinausgehende Pflichten können sich aus den Bestimmungen des
      Telekommunikationsgesetzes sowie des Telemediengesetzes ergeben. Der Kunde
      verpflichtet sich, dies in eigener Verantwortung zu überprüfen und zu
      erfüllen.
    </p>
    <p>
      6.2 Der Kunde verpflichtet sich, keine Inhalte zu veröffentlichen, welche
      Dritte in ihren Rechten verletzen oder sonst gegen geltendes Recht
      verstoßen. Das Hinterlegen von erotischen, pornografischen,
      extremistischen oder gegen die guten Sitten verstoßenden Inhalten ist
      unzulässig. Wir sind berechtigt, den Zugriff des Kunden für den Fall zu
      sperren, dass hiergegen verstoßen wurde. Das gleiche gilt für den Fall,
      dass der Kunde Inhalte veröffentlicht, die geeignet sind, Dritte in ihrer
      Ehre zu verletzen, Personen oder Personengruppen zu beleidigen oder zu
      verunglimpfen. Das gilt auch für den Fall, dass ein tatsächlicher
      Rechtsanspruch nicht gegeben sein sollte. Wir sind nicht verpflichtet, die
      Inhalte unseres Kunden zu überprüfen.
    </p>
    <p>
      6.3 Die Versendung von Spam-Mails ist untersagt. Dies umfasst insbesondere
      die Versendung unzulässiger, unverlangter Werbung an Dritte. Bei der
      Versendung von E-Mails ist es zudem untersagt, falsche Absenderdaten
      anzugeben oder die Identität des Absenders auf sonstige Weise zu
      verschleiern. Bei Nichtbeachtung sind wir berechtigt den Zugriff zu
      sperren.
    </p>

    <h2 class="title is-5" id="7">7. Haftung</h2>
    <p>
      7.1 Für unmittelbare Schäden, Folgeschäden oder entgangenen Gewinn durch
      technische Probleme und Störungen innerhalb des Internets, die nicht in
      unserem Einflussbereich liegen, übernehmen wir keine Haftung.
    </p>
    <p>
      7.2 Gegenüber Unternehmern haften wir bei leicht fahrlässiger Verletzung
      unwesentlicher Vertragspflichten nicht. Dies gilt nicht in allen Fällen
      von Personenschäden und nach Maßgabe des Produkthaftungsgesetzes.
    </p>
    <p>
      Für mittelbare Schäden und Folgeschäden sowie für entgangenen Gewinn
      haften wir gegenüber Unternehmern nur bei Vorsatz und grober
      Fahrlässigkeit. In diesem Fall ist unsere Haftung auf den vertragstypisch
      vorhersehbaren Schaden beschränkt, max. auf 100 % der jährlichen
      Produktmiete.
    </p>
    <p>
      7.3 Verstößt der Kunde mit dem Inhalt seiner Internetseiten gegen die in
      Ziffer 6 genannten Pflichten, insbesondere gegen gesetzliche Verbote oder
      die guten Sitten, so haftet er uns gegenüber auf Ersatz aller hieraus
      entstehenden direkten und indirekten Schäden, auch Vermögensschäden.
      Darüber hinaus verpflichtet sich der Kunde, uns von Ansprüchen Dritter –
      gleich welcher Art – freizustellen, die aus der Rechtswidrigkeit von in
      das Internet gestellten Inhalten resultieren. Die
      Freistellungsverpflichtung umfasst auch die Verpflichtung, uns von
      Rechtsverteidigungskosten (z.B. Gerichts- und Anwaltskosten) vollständig
      freizustellen.
    </p>

    <h2 class="title is-5" id="8">8. Zahlungsbedingungen</h2>
    <p>
      8.1 Es gelten die jeweils aktuellen Preise, die jederzeit unter
      <a href="https://confcloud.de/preise" target="_blank"
        >https://confcloud.de/preise</a
      >
      einsehbar sind.
    </p>
    <p>
      8.2 Je nach vertraglicher Vereinbarung erfolgt eine monatliche,
      vierteljährliche oder jährliche Abrechnung. Bei monatlicher Fälligkeit
      erfolgt die Zahlung ausschließlich durch Erteilung einer
      Einzugsermächtigung. Die sonstige Abrechnung erfolgt durch
      Rechnungsstellung. Sämtliche Entgelte sind dann sofort nach Erhalt der
      Rechnung zur Zahlung fällig.
    </p>
    <p>
      8.3 Bei der Überschreitung von eventuell in der Rechnung eingeräumten
      Zahlungsfristen sind wir auch ohne Mahnung berechtigt, Verzugszinsen zu
      berechnen.
    </p>
    <p>
      Handelt es sich bei dem Kunden um einen Verbraucher, beträgt die Höhe des
      Verzugszinses 5 Prozentpunkte über dem Basiszinssatz. Handelt es sich bei
      dem Kunden um einen Unternehmer, beträgt die Höhe des Verzugszinses 8
      Prozentpunkte über dem Basiszinssatz.
    </p>
    <p>
      8.4 Wir sind darüber hinaus berechtigt, im Verzugsfall die Internetpräsenz
      des Kunden zu sperren und alle sonstigen Leistungen zurückzubehalten.
    </p>
    <p>
      8.5 Die Annahme von Schecks erfolgt nur erfüllungshalber.
    </p>
    <p>
      8.6 Rechnungen werden per E-Mail als Anhang zugestellt. Bei
      Zustellungswunsch per Brief sind wir berechtigt, eine angemessene
      Bearbeitungsgebühr zu erheben. Bei rückwirkender Rechnungsänderung, welche
      nicht durch Verschulden von uns zustande kommt, sind wir berechtigt eine
      angemessene Bearbeitungsgebühr zu erheben.
    </p>

    <h2 class="title is-5" id="9">9. Vertragsdauer/Kündigung/Erfüllungsort</h2>
    <p>
      9.1 Soweit vertraglich nichts anderes vereinbart wurde, werden die
      Verträge auf unbefristete Zeit geschlossen.
    </p>
    <p>
      9.2 Der Vertrag ist von beiden Seiten jeweils mit einer Frist von 30 Tagen
      zum Monatsende, ohne Angabe von Gründen, kündbar, frühestens jedoch zum
      Ablauf der jeweils vertraglich vereinbarten Mindestvertragslaufzeit. Eine
      Kündigung kann in Textform per Brief, Fax, E-Mail oder über den
      gesicherten Online-Administrationsbereich erfolgen, soweit diese
      Möglichkeit zur Verfügung steht.
    </p>
    <p>
      9.3 Wir sind darüber hinaus berechtigt, das Vertragsverhältnis aus
      wichtigem Grund ohne Einhaltung einer Frist zu kündigen. Ein solcher
      wichtiger Grund liegt unter anderem dann vor, wenn der Kunde für zwei
      aufeinander folgende Monate mit der Bezahlung eines nicht unerheblichen
      Teils der Vergütung sich in Verzug befindet. Ein solcher wichtiger Grund
      kann unter anderem auch darin liegen, dass der Kunde wesentlich oder trotz
      Abmahnung gegen die Pflichten aus Ziffer 6 verstößt. Ein weiterer
      wichtiger Grund welcher zur Sperrung oder fristlosen Kündigung führen
      kann, liegt vor, wenn der Kunde Inhalte verwendet, welche das
      Regelbetriebsverhalten oder die Sicherheit des Servers beeinträchtigen
      könnten.
    </p>
    <p>
      9.4 Erfüllungsort für alle Leistungen aus diesem Vertrag ist Steinen.
      Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist das für
      Steinen örtlich zuständige Gericht, sofern der Kunde Kaufmann, juristische
      Person des öffentlichen Rechts, oder öffentlich rechtlichen
      Sondervermögens ist. Dasselbe gilt, wenn der Kunde keinen allgemeinen
      Gerichtsstand in Deutschland hat oder Wohnsitz oder gewöhnlicher
      Aufenthalt zum Zeitpunkt der Klageerhebung nicht bekannt sind. Wir sind
      darüber hinaus berechtigt, am Sitz des Kunden zu klagen.
    </p>
    <p>
      9.5 Beabsichtigt der Kunde die Übertragung seiner vertraglichen Rechte auf
      eine andere Person, bedarf er hierfür unserer Zustimmung. Eine Übertragung
      der vertraglichen Rechte kann nur schriftlich per Brief, Fax oder über den
      gesicherten Online-Administrationsbereich erfolgen, soweit diese
      Möglichkeit zur Verfügung steht. Bei einer Übertragung per Brief oder Fax
      muss der bisherige und neue Vertragspartner eigenhändig unterschreiben.
    </p>

    <h2 class="title is-5" id="10">10. Regelungen für Wiederverkäufer</h2>
    <p>
      10.1 Der Kunde ist berechtigt, Dritten ein vertragliches Nutzungsrecht an
      den von uns für ihn betreuten Internetpräsenzen einzuräumen. In diesem
      Fall bleibt der Kunde dennoch alleiniger Vertragspartner. Er ist
      verpflichtet, sämtliche Vertragsbedingungen, die sich aus den Allgemeinen
      Geschäftsbedingungen sowie aus unseren Bestellformularen ergeben,
      innervertraglich an den Dritten weiterzuleiten und diesen zur Einhaltung
      dieser Bedingungen zu verpflichten. Dies gilt auch für die Verpflichtung
      aus Ziffer 1.3 dieser Allgemeinen Geschäftsbedingungen.
    </p>
    <p>
      10.2 Sind für Änderungen sämtlicher Art Mitwirkungshandlungen des Dritten
      erforderlich, so stellt der Kunde innervertraglich sicher, dass diese
      Mitwirkungspflichten eingehalten werden. Der Kunde wird uns auf
      Anforderung die Adressdaten nebst Ansprechpartner des Dritten mitteilen.
      Wir sind berechtigt, im Falle von Änderungen unmittelbar an den Dritten
      heranzutreten, um von diesem schriftlich die Zustimmung zu den Änderungen
      zu verlangen.
    </p>
    <p>
      10.3 Verstößt der Dritte gegen Vertragspflichten, erfüllt er
      Mitwirkungspflichten nicht oder ergeben sich anderweitig Probleme an der
      Einräumung von Nutzungsrechten an Dritte, so haftet der Kunde uns
      gegenüber für alle hieraus resultierenden Schäden. Darüber hinaus stellt
      uns der Kunde von sämtlichen Ansprüchen frei, die sowohl der Dritte als
      auch andere an uns stellen werden.
    </p>

    <h2 class="title is-5" id="11">11. Widerrufsbelehrung</h2>
    <p>
      <strong>11.1 Widerrufsrecht:</strong>
    </p>
    <p>
      Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen
      Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag
      des Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie
      Florian Freund Webentwicklung, Im Wolfischbühl 33/4, 79585 Steinen,
      Telefon: +49, E-Mail:
      <a class="link-single-internal" href="mailto:info@confcloud.de"
        >info@confcloud.de</a
      >
      mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter
      Brief, E-Mail oder über den gesicherten Online-Administrationsbereich)
      über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie
      können dafür das
      <a class="link-single-internal" href="/legal/widerrufsformular"
        >Muster-Widerrufsformular</a
      >
      verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der
      Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung
      des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
    </p>
    <p>
      <strong>11.2 Folgen des Widerrufs</strong>
    </p>
    <p>
      Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
      wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
      Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine
      andere Art der Lieferung als die von uns angebotene, günstigste
      Standardlieferung gewählt haben), unverzüglich und spätestens binnen
      vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren
      Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung
      verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
      Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich
      etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser
      Rückzahlung Entgelte berechnet.
    </p>
    <p>
      Bei Erbringung von Dienstleistungen:
    </p>
    <p>
      Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist
      beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, der
      dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des
      Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits
      erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag
      vorgesehenen Dienstleistungen entspricht.
    </p>

    <h2>12. Rückfragen und Beanstandungen</h2>
    <p>
      Rückfragen und Beanstandungen sind an Florian Freund Webentwicklung, Im
      Wolfischbühl 33/4, 79585 Steinen zu richten.
    </p>
    <p>
      Stand: 05.05.2020
    </p>
    <p>
      Die AGBs können
      <a href="javascript:window.print()">hier</a>
      ausgedruckt werden.
    </p>
  </div>
</template>

<script>
export default {
  name: "DocumentsTerms"
};
</script>

<style scoped lang="scss">
.document {
  max-width: 35rem;
  margin: 0 auto;
}
</style>
